export default __webpack_public_path__ + "static/media/teaching-features_img.6ee52051.jpg";